module.exports = __webpack_public_path__ + "media/images/donation/how-to-use5-429f335c085d31680adb5cbc34534b5c.jpg";